import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SEVERITY } from '../../utils/Snackbar';
import { get, put } from '../../utils/Api';
import { useParams } from "react-router";
import { useNavigate } from "react-router";

import PersonIcon from '@mui/icons-material/Person';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import StaticHeader from '../../utils/StaticHeader';

export default function UsuarioDialog({
  version,
  setLoading,
  handleMessage,
  mainError,
  setError,
  changeUsuario
}) {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [podeAlterarPerfil,setPodeAlterarPerfil] = useState(false);
  const [perfis,setPerfis] = useState([]);

  const [usuarioAlterado,setUsuarioAlterado] = useState({
    usuario_uuid: '',
    usuario_email: '',
    usuario_nome: '',
    perfil_uuid: '',
    usuario_ativo: false,
    usuario_administrador: false,
  });

  const nomeNaoEhValido = (nome) => {
    return (nome.trim().length < 3);
  };

  const handleChange = (event) => {
    if (mainError) { return; }

    /* Obter valores do submit */
    const data = new FormData(event.currentTarget);

    /* Valores do documento */
    let usuario_nome = data.get('usuario_nome');
    const perfil_uuid = usuarioAlterado.perfil_uuid;
    const usuario_ativo = usuarioAlterado.usuario_ativo;

    /* Validações */
    if ((usuario_nome === undefined) || (usuario_nome === null) || (usuario_nome === '') || nomeNaoEhValido(usuario_nome)) {
      handleMessage('Nome do usuário inválido!',SEVERITY.WARNING.toString(),'',false);
      return;
    }
    const usuario_nome_trim = usuario_nome.trim();

    if (podeAlterarPerfil) {
      if (
        (perfil_uuid === undefined) || (perfil_uuid === null) || (perfil_uuid === '') ||
        !perfis.some(perfil => perfil.perfil_uuid === perfil_uuid)
      ) {
        handleMessage('Perfil do usuário inválido!',SEVERITY.WARNING.toString(),'',false);
        return;
      }

      if ((usuario_ativo === undefined) || (usuario_ativo === null) || (usuario_ativo !== true && usuario_ativo !== false)) {
        handleMessage('Status do usuário inválido!',SEVERITY.WARNING.toString(),'',false);
        return;
      }
    }
    /* Validações */

    /* Alterar dados do usuário */
    setLoading(true);

    put(`api/usuario/${usuarioAlterado.usuario_uuid}`,{
      usuario_nome: usuario_nome_trim,
      perfil_uuid: perfil_uuid,
      usuario_ativo: usuario_ativo,
    },(json)=>{
      setLoading(false);
      handleMessage('Usuário alterado com sucesso!',SEVERITY.SUCCESS.toString(),'',false);

      if (json.alterado_pelo_proprio_usuario) {
        changeUsuario(json.usuario,json.session_token,()=>{
          closeUsuarioDialog();
        });
      } else {
        closeUsuarioDialog();
      }

    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });
    /* Alterar dados do usuário */
  };

  const changeUsuarioAlteradoPerfilUUID = (perfilUUID) => {
    setUsuarioAlterado((dados) => ({
      ...dados,
      perfil_uuid: perfilUUID,
    }));
  };

  const changeUsuarioAlteradoAtivo = (ativo) => {
    setUsuarioAlterado((dados) => ({
      ...dados,
      usuario_ativo: ativo,
    }));
  };

  const closeUsuarioDialog = () => {
    navigate(-1);
  };

  useEffect(()=>{
    setLoading(true);
    get(`api/usuarios-para-alterar/${uuid}`,(json)=>{

      setUsuarioAlterado((dados) => ({
        ...dados,
        usuario_uuid: json.usuario_alterado.usuario_uuid,
        usuario_email: json.usuario_alterado.usuario_email,
        usuario_nome: json.usuario_alterado.usuario_nome,
        perfil_uuid: json.usuario_alterado.perfil_uuid,
        usuario_ativo: json.usuario_alterado.usuario_ativo ? true : false,
        usuario_administrador: json.usuario_alterado.usuario_administrador ? true : false,
      }));

      setPodeAlterarPerfil(json.pode_alterar_perfil);
      setPerfis(json.perfis);

      setLoading(false);

    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });
  },[]);

  return (
    <StaticHeader
      version={version}
      setLoading={setLoading}
      handleMessage={handleMessage}
      error={mainError}
      setError={setError}>
      <Dialog
        closeAfterTransition={false}
        open={true}
        onClose={()=>{}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          handleChange(event);
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
            <PersonIcon sx={{ display: 'flex' }} />
            <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
              Alterar Usuário
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{ width: { xs: 'auto', sm: 400 } }}>

          <Grid
            container
            spacing={1}
            sx={{
              marginTop: '20px',
            }}>

            <Grid item="true" size={12} sx={{ marginBottom: '10px' }}>
              <TextField
                fullWidth
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_email"
                label="E-mail do Usuário"
                defaultValue={usuarioAlterado.usuario_email}
                disabled
              />
            </Grid>

            <Grid item="true" size={12} sx={{ marginBottom: '10px' }}>
              <TextField
                fullWidth
                required
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_nome"
                name="usuario_nome"
                label="Nome do Usuário"
                defaultValue={usuarioAlterado.usuario_nome}
              />
            </Grid>

            <Grid item="true" size={12} sx={{ marginBottom: '10px' }}>
              <TextField
                fullWidth
                required={podeAlterarPerfil}
                disabled={!podeAlterarPerfil}
                slotProps={{ inputLabel: { shrink: true } }}
                id="perfil_uuid"
                select
                label="Perfil do Usuário"
                value={usuarioAlterado.perfil_uuid}
                onChange={(event)=>{
                  changeUsuarioAlteradoPerfilUUID(event.target.value);
                }}
              >
                {perfis.map((option) => (
                  <MenuItem key={option.perfil_uuid} value={option.perfil_uuid}>
                    {option.perfil_nome}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item="true" size={12} sx={{ marginBottom: '10px' }}>
              <TextField
                fullWidth
                required={podeAlterarPerfil}
                disabled={!podeAlterarPerfil}
                slotProps={{ inputLabel: { shrink: true } }}
                id="usuario_ativo"
                select
                label="Usuário Ativo"
                value={usuarioAlterado.usuario_ativo}
                onChange={(event)=>{
                  changeUsuarioAlteradoAtivo(event.target.value);
                }}
              >
                {[
                  {ativo: true, label: 'Ativo'},
                  {ativo: false, label: 'Inativo'}
                ].map((option) => (
                  <MenuItem key={option.label} value={option.ativo}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

          </Grid>

        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'space-between',
          }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={()=>{
              closeUsuarioDialog();
            }}>
            Voltar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            startIcon={<SaveIcon />}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </StaticHeader>
  );
}
